import Sentry from "@similarweb/sentry-logger";

import { ADDON_TYPE_NAME_DICT, type AddonTypeName } from "app/contexts/AddonStateContext/const";
import { useApiQuery } from "app/modules/api-client";

interface IUseNoTouchPurchasePackagesQueryProps {
    addonType: AddonTypeName;
}

export const useNoTouchPurchasePackagesQuery = ({ addonType }: IUseNoTouchPurchasePackagesQueryProps) => {
    const params = {
        addOnType: addonType === ADDON_TYPE_NAME_DICT.CountryFilterDynamic ? "CountryFilter" : addonType,
    };

    return useApiQuery(
        {
            tag: "NoTouchAddonsPurchase",
            methodName: "notouchAddonsPackagesList",
            options: {
                enabled: () => !!addonType,
                throwOnError: (e) => {
                    Sentry.errorTracker({
                        message: "useNoTouchPurchasePackagesQuery",
                        e: new Error("Packages cannot be retrieved", { cause: e }),
                        params,
                    });

                    return false;
                },
            },
        },
        params,
    );
};
